import React, { useState, useEffect } from "react";
import { Input } from "antd";

const EditTabsAtonSettings = ({ sendAtonState, organization }) => {
  const [crmId, setCrmId] = useState("");
  const [stockroom, setStockroom] = useState("");

  const atonState = {
    crmId,
    stockroom,
  };

  useEffect(() => {
    sendAtonState(atonState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crmId, stockroom]);

  useEffect(() => {
    setCrmId(organization.myMenuConfiguration.atonConfiguration?.crmId || "0");
    setStockroom(
      organization.myMenuConfiguration.atonConfiguration?.stockroom || "0"
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization]);

  return (
    <>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">Crm Id</label>
          <Input
            value={crmId}
            onChange={(e) => setCrmId(e.target.value)}
            placeholder="Въведи стойност"
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Stock room
          </label>
          <Input
            value={stockroom}
            onChange={(e) => setStockroom(e.target.value)}
            placeholder="Въведи стойност"
          />
        </div>
      </div>
    </>
  );
};

export default EditTabsAtonSettings;
